module.exports = __webpack_public_path__ + "img/readingtask1.df06762a.png";